module.exports = __webpack_public_path__ + "img/author-3@2x.c191469.jpg";